<app-pias-layout>
    <div pias-layout-content>
        @if(this.setSprinner()) {
        <div class="pias-spinner">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        }
        <div id="view-onboarding-application-container" class="container-fluid">
            <div id="view-onboarding-application-header" class="d-flex justify-content-between">
                <h5 class="page-header">Agent Onboarding</h5>
            </div>

            <mat-card appearance="raised" class="pias-card">
                <mat-card-content class="pias-card-content">
                    <form class="row align-items-start" [formGroup]="viewOnboardApplicationFg">
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Who are you onboarding?</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="designation" placeholder="Financial Services Manager"
                                    value="Financial Services Manager" readonly type="text" />
                            </mat-form-field>
                        </p>
                        @if (showName) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name (As per NRIC)</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="name" readonly type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showCompany) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name Of Company</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="companyName" readonly type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showPreferredName) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Preferred Name</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="preferredName" readonly type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showBranch) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Branch</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="branch" readonly value="Branch" type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showDirector) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Financial Services Director</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="financialServicesDirector" readonly type="text"
                                    value="Financial Services Director" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showManager) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Financial Services Manager</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="financialServicesManager"
                                    placeholder="Financial Services Manager" value="Financial Services Manager" readonly
                                    type="text" />
                            </mat-form-field>
                        </p>
                        }

                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">{{ emailLabel }}</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="personalEmailAddress" type="email" readonly />
                            </mat-form-field>
                        </p>
                        @if (showReferral) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name of Referral</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="nameofReferral" type="text" readonly />
                            </mat-form-field>
                        </p>
                        }
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Remarks</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p>
                        <!-- <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label>Remarks by Rep</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label>Remarks by Propel onabording team</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label>Remarks by BDM</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label>Remarks by AMU</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label>Remarks by AMU Manager</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager" type="text" readonly />
                            </mat-form-field>
                        </p> -->

                    </form>

                </mat-card-content>
                <mat-divider class="pias-divider"></mat-divider>
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">

                        <!-- Cancel -->
                        <button type="button" class="btn btn-cancel btn-lg" [routerLink]="'/agent-onboarding'">
                            Cancel
                        </button>

                        <!-- Edit-details -->
                        <div>
                            @if(status == 'Draft Created' && (this.currentUserRole == 'Director' || this.currentUserRole
                            == 'Manager' || this.currentUserRole == 'Advisor' )){
                            <button type="button" class="btn btn-submit btn-lg" (click)="navigateEditDetails()">
                                Edit
                            </button>
                            }
                        </div>

                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</app-pias-layout>